// 消息中心
import { fetchMessageUnreadCount, markMessageRead } from 'apis/community'
import * as types from 'store/mutation-types'
import { MSG_TYPE } from 'const/common'

const state = {
  msgBoxVisible: false, // 消息弹框是否显示，用于控制显示不更新当前菜单
  unreadCount: {},
  curColumnId: MSG_TYPE.TRADE // 默认当前菜单为第一个
}

const getters = {
  hasUnreadMsg: state =>
    Object.keys(MSG_TYPE).some(d => state.unreadCount[d] > 0),
  msgCurColumnId: state => state.curColumnId,
  msgUnreadCount: state => state.unreadCount,
  msgBoxVisible: state => state.msgBoxVisible
}

const mutations = {
  [types.UPDATE_MSG_UNREAD_COUNT](state, unreadCount) {
    state.unreadCount = { ...state.unreadCount, ...unreadCount }
  },
  [types.UPDATE_MSG_VISIBLE](state, flag) {
    state.msgBoxVisible = flag
  },
  [types.UPDATE_MSG_CUR_ID](state, columnId) {
    state.curColumnId = columnId
  }
}

const actions = {
  async getMessageUnreadCount({ commit, getters }) {
    const data = await fetchMessageUnreadCount()
    commit(types.UPDATE_MSG_UNREAD_COUNT, data)
  },
  async readMessage({ commit, dispatch }, columnId) {
    markMessageRead(columnId)
    commit(types.UPDATE_MSG_UNREAD_COUNT, { [columnId]: 0 })
    dispatch('getMessageUnreadCount')
  },
  changeMessageColumn({ commit }, columnId) {
    commit(types.UPDATE_MSG_CUR_ID, columnId)
  },
  openMessageModal({ commit }, columnId) {
    commit(types.UPDATE_MSG_VISIBLE)
    if (columnId) commit(types.UPDATE_MSG_CUR_ID, columnId)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
